import $ from 'jquery';
import _ from 'lodash';
import '~/app/assets/javascripts/forked_libs/select2';
import iosFocusFix from 'utils/ios_focus_fix';

class Selector {
  constructor(element, options = {}) {
    this.$element = $(element);
    this.options = {
      allowClear: false,
      multiple: false,
      placeholder: '',
      theme: 'normal-r',
      templateResult: ({ text }) => text,
      ...options,
    };

    this.listen();
    this.init();
  }

  init() {
    const {
      allowClear,
      maximumInputLength,
      minimumInputLength,
      multiple,
      placeholder,
      theme,
      tags,
      templateResult,
    } = this.options;

    this.$element
      .select2({
        allowClear,
        maximumInputLength,
        minimumInputLength,
        multiple,
        placeholder,
        tags,
        templateResult,
        theme,
        ...this.pluginOptions,
      });

    // Fixes select2v3 removing select2v4 initial class
    this.$element
      .removeClass('select2-hidden-accessible')
      .addClass('hide');
  }

  listen() {
    this.$element
      .on('select2:open', this.onOpen.bind(this))
      .on('select2:selecting', this.onSelecting.bind(this))
      .on('select2:select', this.onSelect.bind(this))
      .on('select2:unselect', this.onUnselect.bind(this));

    iosFocusFix(this.$element.closest('div'));
  }

  onOpen() {
    const { onOpen } = this.options;

    if (_.isFunction(onOpen)) onOpen();

    // Forces dropdown repositioning after the content insertion
    setTimeout(() => $(window).scroll());
  }

  onSelecting() {
    const { results } = this.$element.data('select2') || {};

    this.originalQuery = results && results.lastParams && results.lastParams.term;
  }

  onSelect() {
    const { onChange } = this.options;

    if (_.isFunction(onChange)) onChange();
  }

  onUnselect() {
    const { onChange } = this.options;
    this.$element.empty();

    if (_.isFunction(onChange)) onChange();
  }

  onError() {
    const $message = $('.select2-results__option.loading-results');
    $message.text('Ocorreu um erro inesperado. Tente novamente.');
  }

  clear() {
    this.$element.val(null).trigger('change');
  }
}

export default Selector;
